var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.83468 12.3343C4.83468 13.3622 3.99501 14.2019 2.96714 14.2019C1.93928 14.2019 1.09961 13.3622 1.09961 12.3343C1.09961 11.3065 1.93928 10.4668 2.96714 10.4668H4.83468V12.3343Z",
    fill: "#E01E5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77539 12.3343C5.77539 11.3065 6.61506 10.4668 7.64293 10.4668C8.67079 10.4668 9.51046 11.3065 9.51046 12.3343V17.0104C9.51046 18.0383 8.67079 18.8779 7.64293 18.8779C6.61506 18.8779 5.77539 18.0383 5.77539 17.0104V12.3343Z",
    fill: "#E01E5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64293 4.83468C6.61506 4.83468 5.77539 3.99501 5.77539 2.96714C5.77539 1.93928 6.61506 1.09961 7.64293 1.09961C8.67079 1.09961 9.51046 1.93928 9.51046 2.96714V4.83468H7.64293Z",
    fill: "#36C5F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64322 5.77539C8.67109 5.77539 9.51076 6.61506 9.51076 7.64293C9.51076 8.67079 8.67109 9.51046 7.64322 9.51046H2.96715C1.93928 9.51046 1.09961 8.67079 1.09961 7.64293C1.09961 6.61506 1.93928 5.77539 2.96715 5.77539H7.64322Z",
    fill: "#36C5F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1426 7.64293C15.1426 6.61506 15.9822 5.77539 17.0101 5.77539C18.038 5.77539 18.8776 6.61506 18.8776 7.64293C18.8776 8.67079 18.038 9.51046 17.0101 9.51046H15.1426V7.64293Z",
    fill: "#2EB67D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2019 7.64322C14.2019 8.67109 13.3622 9.51076 12.3343 9.51076C11.3065 9.51076 10.4668 8.67109 10.4668 7.64322V2.96715C10.4668 1.93928 11.3065 1.09961 12.3343 1.09961C13.3622 1.09961 14.2019 1.93928 14.2019 2.96715V7.64322Z",
    fill: "#2EB67D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3343 15.1426C13.3622 15.1426 14.2019 15.9822 14.2019 17.0101C14.2019 18.038 13.3622 18.8776 12.3343 18.8776C11.3065 18.8776 10.4668 18.038 10.4668 17.0101V15.1426H12.3343Z",
    fill: "#ECB22E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3343 14.2019C11.3065 14.2019 10.4668 13.3622 10.4668 12.3343C10.4668 11.3065 11.3065 10.4668 12.3343 10.4668H17.0104C18.0383 10.4668 18.8779 11.3065 18.8779 12.3343C18.8779 13.3622 18.0383 14.2019 17.0104 14.2019H12.3343Z",
    fill: "#ECB22E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.c41ca0436399066a81c64ea9ffd4b915.svg";
export { ForwardRef as ReactComponent };